import { gql } from "@apollo/client";

export const MUTATION_UPDATE_USER_TO_PROCESS_AND_INSERT_TRANSDUCTION = gql`
  mutation MUTATION_UPDATE_USER_TO_PROCESS_AND_INSERT_TRANSDUCTION(
    $updates: userToProcess_set_input, 
    $userToProcessId: uuid,
    $transductionTemplated: String, 
    $transduction: String, 
    $title: String, 
    $patientId: uuid, 
    $doctorId: uuid
  ) {
    update_userToProcess(_set: $updates, where: {id: {_eq: $userToProcessId}}) {
      affected_rows
      returning {
        created_at
        customFormFieldChanges
        descript
        doctorId
        id
        isAcepted
        isChecked
        latestCustomFormId
        nextUpdate
        processId
        stageId
        updated_at
        userId
        doctor {
          name
          lastname
        }
        process {
          id
          processName
        }
      }
    }
    insert_transductionsHistory(
      objects: {
        transductionTemplated: $transductionTemplated, 
        transduction: $transduction, 
        title: $title, 
        patientId: $patientId, 
        doctorId: $doctorId
      }
    ) {
      affected_rows
      returning {
        created_at
        doctorId
        id
        patientId
        title
        transduction
        transductionTemplated
        url
      }
    }
  }
`

export const MUTATION_INSERT_CREATE_TRANSDUCTION = gql`
  mutation MUTATION_INSERT_CREATE_TRANSDUCTION(
    $transductionTemplated: String, 
    $transduction: String, 
    $title: String, 
    $patientId: uuid, 
    $doctorId: uuid
  ) {
    insert_transductionsHistory(
      objects: {
        transductionTemplated: $transductionTemplated, 
        transduction: $transduction, 
        title: $title, 
        patientId: $patientId, 
        doctorId: $doctorId
      }
    ) {
      affected_rows
      returning {
        created_at
        doctorId
        id
        patientId
        title
        transduction
        transductionTemplated
        url
      }
    }
  }
`

export const MUTATION_UPDATE_TRANSDUCTION = gql`
  mutation MUTATION_UPDATE_TRANSDUCTION(
    $transductionUpdated: transductionsHistory_set_input, 
    $transductionId: uuid
  ) {
    update_transductionsHistory(where: {id: {_eq: $transductionId}}, _set: $transductionUpdated) {
      returning {
        created_at
        doctorId
        id
        title
        patientId
        transduction
        transductionTemplated
        url
        user {
          id
          lastname
          name
        }
      }
    }
  }
`